require('./stylesheets/style.scss');

angular.module('pages.agreementsArchive', [])
    .config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider
        .state('pages.agreementsArchive', {
            url: 'agreements-archive',
            template: require('./templates/index.html'),
            controller: require('./controllers/agreementsArchive'),
            data: {},
            params: {},
            pageTrack: '/agreementsArchive'
        });
}

module.exports = 'pages.agreementsArchive';



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/agreements-archive/index.js
 ** module id = 258
 ** module chunks = 1
 **/